"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LensAbi = exports.erc20abi = exports.iwethabi = exports.TwapAbi = exports.Configs = exports.getOrderFillDelay = exports.buildOrder = exports.parseOrderStatus = exports.getOrderLimitPriceRate = exports.getOrderExcecutionRate = exports.networks = exports.eqIgnoreCase = exports.amountUi = exports.amountBN = exports.getNetwork = exports.isNativeAddress = exports.TwapSDK = exports.constructSDK = void 0;
var configs_json_1 = __importDefault(require("@orbs-network/twap/configs.json"));
exports.Configs = configs_json_1.default;
var twap_abi_json_1 = __importDefault(require("@orbs-network/twap/twap.abi.json"));
exports.TwapAbi = twap_abi_json_1.default;
var lens_abi_json_1 = __importDefault(require("@orbs-network/twap/lens.abi.json"));
exports.LensAbi = lens_abi_json_1.default;
var iwethabi_json_1 = __importDefault(require("./lib/abi/iwethabi.json"));
exports.iwethabi = iwethabi_json_1.default;
var erc20abi_json_1 = __importDefault(require("./lib/abi/erc20abi.json"));
exports.erc20abi = erc20abi_json_1.default;
__exportStar(require("./lib/types"), exports);
__exportStar(require("./lib/consts"), exports);
var constructSDK_1 = require("./lib/constructSDK");
Object.defineProperty(exports, "constructSDK", { enumerable: true, get: function () { return constructSDK_1.constructSDK; } });
Object.defineProperty(exports, "TwapSDK", { enumerable: true, get: function () { return constructSDK_1.TwapSDK; } });
__exportStar(require("./lib/lib"), exports);
var utils_1 = require("./lib/utils");
Object.defineProperty(exports, "isNativeAddress", { enumerable: true, get: function () { return utils_1.isNativeAddress; } });
Object.defineProperty(exports, "getNetwork", { enumerable: true, get: function () { return utils_1.getNetwork; } });
Object.defineProperty(exports, "amountBN", { enumerable: true, get: function () { return utils_1.amountBN; } });
Object.defineProperty(exports, "amountUi", { enumerable: true, get: function () { return utils_1.amountUi; } });
Object.defineProperty(exports, "eqIgnoreCase", { enumerable: true, get: function () { return utils_1.eqIgnoreCase; } });
var networks_1 = require("./lib/networks");
Object.defineProperty(exports, "networks", { enumerable: true, get: function () { return networks_1.networks; } });
var orders_1 = require("./lib/orders");
Object.defineProperty(exports, "getOrderExcecutionRate", { enumerable: true, get: function () { return orders_1.getOrderExcecutionRate; } });
Object.defineProperty(exports, "getOrderLimitPriceRate", { enumerable: true, get: function () { return orders_1.getOrderLimitPriceRate; } });
Object.defineProperty(exports, "parseOrderStatus", { enumerable: true, get: function () { return orders_1.parseOrderStatus; } });
Object.defineProperty(exports, "buildOrder", { enumerable: true, get: function () { return orders_1.buildOrder; } });
Object.defineProperty(exports, "getOrderFillDelay", { enumerable: true, get: function () { return orders_1.getOrderFillDelay; } });
